<template>
    <div class="auth-background">
        <svg-sprite></svg-sprite>
        <header-auth></header-auth>
        <router-view></router-view>
        <!-- <loading-screen
            v-show="$store.getters['loadingScreen/getLoading']"
        ></loading-screen> -->
        <loading-screen></loading-screen>
        <footer-auth/>
    </div>
</template>

<script>
import headerAuth from './components/header.vue';
import footerAuth from './components/footer.vue';
export default {
    name: "auth",
    components: {
        headerAuth,
        footerAuth,
    },
};
</script>

<style lang="scss" scoped>
.auth-background {
    @apply w-full min-h-screen p-0 m-0 flex flex-col;
}
</style>
